import { render, staticRenderFns } from "./ArticleFamilyArticlesManager.vue?vue&type=template&id=252c821e&scoped=true&"
import script from "./ArticleFamilyArticlesManager.vue?vue&type=script&lang=js&"
export * from "./ArticleFamilyArticlesManager.vue?vue&type=script&lang=js&"
import style0 from "./ArticleFamilyArticlesManager.vue?vue&type=style&index=0&id=252c821e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252c821e",
  null
  
)

export default component.exports